import React from 'react';
import '../pages/LandingPage.css';
import { Link } from 'react-router-dom';

function Header() {
  return (
     <div>
     <nav className="navbar">
     <div className="nav-container">
     <div className="nav-links">
     <Link to="/" className="nav-link">
       <div className="logo">
         <img src="/logo.png" alt="Figbot Logo" className="logo-icon" />
         <span className="logo-text">Figbot</span>
       </div>
       </Link>
       </div>
       <div className="nav-links">
         <Link to="/about" className="nav-link">About</Link>
         <a href="#features">Features</a>
         <a href="#pricing">Pricing</a>
         <Link to="/login" className="nav-link">Login</Link>
         <Link to="/signup" className="nav-button">Get Started</Link>
       </div>
     </div>
   </nav>
   </div>
  )
}

export default Header